import { Timer, CheckCircle2, AlertTriangle, Clock } from "lucide-react"
import type { LucideIcon } from "lucide-react"
import type { KpiStat } from "../types/analytics.types"
import { EmptyState } from "../../../components/EmptyState"

const ICON_MAP: Record<string, LucideIcon> = {
  "timer": Timer,
  "check-circle": CheckCircle2,
  "alert-triangle": AlertTriangle,
  "clock": Clock,
}

interface KpiCardsProps {
  stats?: KpiStat[]
  columns?: 3 | 4
  emptyTitle?: string
  emptyMessage?: string
}

export function KpiCards({ stats, columns = 4, emptyTitle, emptyMessage }: KpiCardsProps): JSX.Element {
  if (!stats || stats.length === 0) {
    return (
      <EmptyState
        variant="section"
        title={emptyTitle ?? 'No KPI data yet'}
        message={emptyMessage ?? "Your headline metrics will appear here once data starts flowing."}
      />
    )
  }

  const gridColsClass = columns === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-4'

  return (
    <div className={`grid grid-cols-2 ${gridColsClass} gap-4`}>
      {stats.map((stat) => {
        const Icon = ICON_MAP[stat.icon] ?? Timer
        return (
          <div
            key={stat.label}
            className="flex items-start gap-3 rounded-xl border border-gray-200 bg-white p-4"
          >
            <Icon className={`mt-0.5 h-5 w-5 ${stat.color}`} />
            <div>
              <p className="text-2xl font-bold leading-tight text-gray-900">{stat.value}</p>
              <p className="text-sm text-gray-500">{stat.label}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
